import { createContext } from "react";

export interface ISettingsContext {
    defaultCountryCode: string,
    countryCode: string,
    setCountryCode: (value: string) => void
}

export const SettingsContext = createContext<ISettingsContext>({} as ISettingsContext);